import dynamic from "next/dynamic";
const RegularAssetComponent = dynamic(()=>import("./regular-asset-component"));
import RegularAssetConfig from "./regular-asset-config";
import RegularAssetAdvancedConfig from "./regular-asset-advanced-config";
export default {
    RegularAssetComponent,
    RegularAssetConfig,
    RegularAssetAdvancedConfig
};
